module.exports = __webpack_public_path__ + "img/Dance-DP-t-26696-001.eef5d789.jpg";